import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './CardListItemGroup.module.css';

export type CardListItemGroupProps = ComponentProps<'div'> & {
  label: string;
};

export const CardListItemGroup: FunctionComponent<CardListItemGroupProps> =
  React.memo((props) => {
    const { children, label, className, ...remainingProps } = prepareProps({
      props
    });

    return (
      <div
        {...remainingProps}
        className={classes(className, styles.group)}
      >
        {label ? <div className={styles.label}>{label}</div> : undefined}
        {children}
      </div>
    );
  });
